import React from "react";

import { CheckCircleIcon } from "@heroicons/react/24/outline";
import { useTranslations } from "next-intl";

interface FormSuccessMessageProps {
    variant: "contact" | "feedback";
}

const FormSuccessMessage = ({ variant }: FormSuccessMessageProps) => {
    const t = useTranslations("NewHome.contact");

    return (
        <div className="rounded-3xl border border-black p-8 md:p-12 text-center">
            <div className="flex justify-center mb-6">
                <CheckCircleIcon className="w-16 h-16 text-primary-200" />
            </div>
            <h3 className="text-2xl font-semibold text-black mb-4">{t(`${variant}.success.title`)}</h3>
            <p className="text-black mb-6">{t(`${variant}.success.message`)}</p>
        </div>
    );
};

export default FormSuccessMessage;
